module.exports = "/_next/static/images/68b944360effb762ab610fb2331dc970-group-man-building@1x.jpg";